export default {
  // 物品管理: '#icon-desktop',
  教务管理: '#icon-kechengbeifen',
  财务管家: '#icon-caiwuguanjia',
  学校管理: '#icon-xuexiaoguanli',
  数据中心: '#icon-shujuzhongxin',
  会员积分: '#icon-huiyuanjifen',
  首页: '#icon-shouye',
  应用中心: '#icon-a-Group257',
  储值管理: '#icon-chuzhiguanli',
  收银管理: '#icon-shouyinguanli',
};
